export const IncidentHeaderDialogStates = {
    None: "None",
    Delete: "Delete",
    PreviousStatus: "PreviousStatus",
    NextStatus: "NextStatus",
    SendToProcessing: "SendToProcessing",
    PilotComplete: "PilotComplete",
    CorrectionNeeded: "CorrectionNeeded",
    PilotPdf: "PilotPdf",
    GeneratePilotPdf: "GeneratePilotPdf",
    Pdf: "Pdf",
    GeneratePdf: "GeneratePdf",
    SendToArchive: "SendToArchive",
    CorrectionCaseworker: "CorrectionCaseworker",
};

export const IncidentStatuses = {
    Draft: "DRAFT",
    AwaitingProcessing: "AWAITING_PROCESSING",
    BeingProcessed: "BEING_PROCESSED",
    ProcessingFinished: "PROCESSING_FINISHED",
    Archived: "ARCHIVED",
    CorrectionNeeded: "CORRECTION_NEEDED",
    CorrectionCaseworker: "CORRECTION_CASEWORKER",
};

export const IncidentJsonForms = {
    ShipDetails: "SHIP_DETAILS",
    NavigatorDetails: "NAVIGATOR_DETAILS",
    PilotDetails: "PILOT_DETAILS",
    PilotCausations: "PILOT_CAUSATIONS",
    Causations: "CAUSATIONS",
    Consequences: "CONSEQUENCES",
    Violations: "VIOLATION_OF_REGULATIONS",
    Summary: "SUMMARY",
    Weather: "WEATHER_CONDITIONS",
}

export const IncidentMenuEvents = {
    Overview: "OVERVIEW",

    Actors: "ACTORS",
    ActorsShip: "ACTORS-SHIP",
    ActorsNavigator: "ACTORS-NAVIGATOR",
    ActorsPilot: "ACTORS-PILOT",
    ActorsVTS: "ACTORS-VTS",

    Filling: "FILLING",
    FillingCausations: "FILLING-CAUSATIONS",
    FillingConsequences: "FILLING-CONSEQUENCES",
    FillingViolations: "FILLING-VIOLATIONS",
    FillingSummary: "FILLING-SUMMARY",
    FillingWeather: "FILLING-WEATHER",

    Functions: "FUNCTIONS",
    FunctionsImageArchive: "FUNCTIONS-IMAGE-ARCHIVE",
    FunctionsDocumentArchive: "FUNCTIONS-DOCUMENT-ARCHIVE",
    FunctionsTimeline: "FUNCTIONS-TIMELINE",
};

export const FormActions = {
    Details: "DETAILS",
    Information: "INFORMATION",
    Observations: "OBSERVATIONS",
    Voyage: "VOYAGE",
    Dangerous: "DANGEROUS",
    Pilot: "PILOT",
    Procedure: "PROCEDURE",
    Summary: "SUMMARY",
    Description: "DESCRIPTION",
    Factors: "FACTORS",
    CourseOfEventsSummary: "COURSE_OF_EVENTS_SUMMARY",
    CourseOfEventsDescription: "COURSE_OF_EVENTS_DESCRIPTION",
    UnderlyingCausesSummary: "UNDERLYING_CAUSES_SUMMARY",
    ShipObservationDescription: "SHIP_OBSERVATION_DESCRIPTION",
    Improvements: "IMPROVEMENTS",
};

export const IncidentEditStatuses = {
    Caseworker: "Caseworker",
    Pilot: "Pilot",
    Error: "Error",
    None: "None",
    NoAccess: "NoAccess",
    Pdf: "Pdf",
    Processing: "Processing",
};

export const ActorType = {
    VESSEL: "VESSEL",
    PILOT: "PILOT",
    NAVIGATOR: "NAVIGATOR",
    VTS: "VTS",
};

export const actorTypeToDisplayName = (actorType) => {
    switch (actorType) {
        case ActorType.VESSEL:
            return "Fartøy";
        case ActorType.PILOT:
            return "Los";
        case ActorType.NAVIGATOR:
            return "Navigatør";
        case ActorType.VTS:
            return "VTS";
        default:
            return "Ukjent";
    }
};
